import * as actions from './actions'
import reducer from './reducer'
import ConsultaPerfisAdmin from './componentes/ConsultaPerfisAdmin'
import * as TypeAction from './actionTypes'



const config = {
    route: {
        path: '/admin/PerfisAdmin',
        exact: true,
        component: ConsultaPerfisAdmin,
        permissao: "Admin.Perfil.Listar"
    },
    menu: { nome: "PerfisAdmin", rota: '/admin/PerfisAdmin', ordem: 300, permissao: "Admin.Perfil.Listar" },
    reducerConfig: { nome: "PerfisAdminReducer", reducer: reducer }

}

export default config


export { actions, reducer,  TypeAction }




// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/index.js